import * as React from 'react'
import './PlatformArchitecture.css'
// components
import Header from '../components/layouts/Header'
import Footer from '../components/layouts/Footer'
import PlatformArchitectureSection from '../components/sections/PlatformArchitecture'

const PlatformArchitecture = () => (
  <>
    <div id='smooth-wrapper'>
      <div id='smooth-content'>
        <div className='podio platform-architecture-wrapper'>
          <PlatformArchitectureSection />
          <Footer />
        </div>
      </div>
    </div>
    <Header />
  </>
)

export default PlatformArchitecture
